import React, { useState } from 'react'
import { TableComponent } from 'components/common/table-components'

import { get, isEmpty } from 'lodash'
import SearchComponent from 'components/common/search'
import { getFormatedDate } from 'helpers/getDateTime'
import { workOrderTypesPath } from 'components/WorkOrders/utils'
import { FilterPopup, StatusComponent } from 'components/common/others'
import enums from 'Constants/enums'
import useFetchData from 'hooks/fetch-data'
import facilities from 'Services/facilities'
import { TablePagination } from '@material-ui/core'

const WorkOrderList = ({ companyId }) => {
  const [page, setPage] = useState(0)
  const [pageIndex, setPageIndex] = useState(1)
  const [rowsPerPage, setRowsPerPage] = useState(20)
  const [searchString, setSearchString] = useState('')
  const [selectedWOType, setSelectedWOType] = useState({})

  const { loading: woLoading, data: woData } = useFetchData({
    fetch: facilities.getAllWorkOrdersByClientCompanyId,
    payload: { clientCompanyId: companyId, woType: get(selectedWOType, 'value', null), pageindex: pageIndex, pagesize: rowsPerPage, searchString: isEmpty(searchString) ? null : searchString },
    formatter: d => get(d, 'data', null),
    defaultValue: [],
  })

  const columns = [
    { name: 'WO#', accessor: 'manualWoNumber' },
    { name: 'WO Type', render: d => workOrderTypesPath[d.woType]['label'] },
    { name: 'Facility', accessor: 'siteName' },
    { name: 'Start Date', render: d => getFormatedDate(d.startDate.split('T')[0]) },
    { name: 'Due Date', render: d => getFormatedDate(d.dueAt.split('T')[0]) },
    {
      name: 'Status',
      render: d => {
        return <div style={{ padding: '5px 0px' }}>{getWorkOrderStatus(d.status)}</div>
      },
    },
  ]

  const handleWOView = data => {
    const d = workOrderTypesPath[data.woType]['path']
    window.open(`/${d}/${data.woId}`)
  }

  const handleChangePage = (event, newPage) => {
    setPage(newPage)
    setPageIndex(newPage + 1)
  }

  const handleChangeRowsPerPage = event => {
    setRowsPerPage(parseInt(event.target.value, 10))
    setPage(0)
    setPageIndex(1)
  }

  const postSearch = () => {
    setPage(0)
    setPageIndex(1)
  }

  const getWorkOrderStatus = status => {
    const { color, label } = enums.WO_STATUS.find(d => d.value === status)
    return <StatusComponent label={label} color={color} size='small' />
  }

  return (
    <div style={{ background: '#fff', height: 'calc(100vh - 124px)', width: '100%', margin: '20px 0 20px 0px' }}>
      <div className='d-flex justify-content-between align-items-center' style={{ width: '100%', marginBottom: '20px' }}>
        <div>
          <FilterPopup selected={selectedWOType} onChange={d => setSelectedWOType(d)} onClear={() => setSelectedWOType({})} placeholder='WO Type' options={enums.WO_TYPE_LIST} baseClassName='mr-2 mb-2' />
        </div>
        <div className='d-flex align-items-center'>
          <SearchComponent placeholder='Search' postClear={postSearch} postSearch={postSearch} searchString={searchString} setSearchString={setSearchString} />
        </div>
      </div>
      <div className='table-responsive dashboardtblScroll' id='style-1' style={{ height: 'calc(100% - 115px)' }}>
        <TableComponent loading={woLoading} columns={columns} data={get(woData, 'list', [])} isForViewAction={true} onRowClick={d => handleWOView(d)} />
      </div>
      {!isEmpty(get(woData, 'list', [])) && <TablePagination rowsPerPageOptions={[20, 40, 60, 80, 100]} component='div' count={get(woData, 'listsize', 0)} rowsPerPage={rowsPerPage} page={page} onPageChange={handleChangePage} onRowsPerPageChange={handleChangeRowsPerPage} />}
    </div>
  )
}

export default WorkOrderList
